export default "__VITE_ASSET__ersDGawq__"